var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { BackgroundThemeProvider } from '../_internal/theme/BackgroundThemeProvider';
import { Icon } from '../Icon';
import { useCurrentBackground } from '../useCurrentBackground';
import { useThemeVariant } from '../useThemeVariant';
import { IconButtonContainer, IconButtonContent } from './IconButton.style';
export var IconButton = React.forwardRef(function (props, ref) {
    var icon = props.icon, colored = props.colored, _a = props.small, small = _a === void 0 ? false : _a, _b = props.large, large = _b === void 0 ? false : _b, _c = props.tiny, tiny = _c === void 0 ? false : _c, _d = props.background, background = _d === void 0 ? 'none' : _d, _e = props.type, type = _e === void 0 ? 'button' : _e, rest = __rest(props, ["icon", "colored", "small", "large", "tiny", "background", "type"]);
    var theme = useThemeVariant();
    var parentBackgroundColor = useCurrentBackground();
    var backgroundColor = React.useMemo(function () {
        switch (background) {
            case 'inherit':
                return parentBackgroundColor;
            case 'white':
                return '#FFFFFF';
            case 'grey':
                return theme.neutralColor.withIntensityFading[200];
            case 'none':
                return undefined;
        }
    }, [background, parentBackgroundColor, theme.neutralColor]);
    var content = (React.createElement(IconButtonContainer, __assign({}, rest, { ref: ref, "data-small": small, "data-large": large, "data-tiny": tiny, "data-has-bounding-background": backgroundColor && backgroundColor !== parentBackgroundColor, type: type, style: {
            '--icon-button-base-background': backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : 'unset',
        } }),
        React.createElement(IconButtonContent, null,
            React.createElement(Icon, { icon: icon, colored: colored }))));
    return backgroundColor ? (React.createElement(BackgroundThemeProvider, { backgroundColor: backgroundColor }, content)) : (content);
});
//# sourceMappingURL=IconButton.js.map